<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            Subject: Second Request for Verification of Disputed Items on Credit Report
        </p>
        <p>
            Dear {{creditBureau.name}},
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            According to the Fair Credit Reporting Act, Section 609 (a)(1)(A), you are required by federal law to verify - through the physical verification of the original signed consumer contract - any and all accounts you post on a credit report. Otherwise, anyone paying for your reporting services could fax, mail or email in a fraudulent account.
        </p>
        <p class="letter-content">
            I demand to see Verifiable Proof (an original Consumer Contract with my Signature on it) you have on file of the accounts listed below. Your failure to positively verify these accounts has hurt my ability to obtain credit. Under the FCRA, unverified accounts must be removed and if you are unable to provide me a copy of verifiable proof, you must remove the accounts listed below.
        </p>
        <p class="letter-content">
            I must emphasize that the required original creditor's documentation has not been provided to me, as required by FCRA Sections 609(a)(1)(A) and 611(a)(1)(A). The absence of a consumer contract with my signature is notable. According to FCRA Section 611(5)(A), you are obligated to "promptly DELETE all information which cannot be verified."
        </p>
        <p class="letter-content">
            I demand the following accounts be verified or removed immediately:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            Also, please remove all non-account holding inquiries over 30 days old and add a Promotional Suppression to my credit file.
        </p>
        <p>
            Sincerely
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                address,
            };
        },
    };
</script>
